import { InjectionToken } from '@angular/core';

export const USERDETAILS_DETAILED_TITLE = new InjectionToken<boolean>(
  'user-details-client-detailed-title',
);
